import { FC, useMemo } from "react";
import { useRecoilValue } from "recoil";

import {
  appLanguageSelector,
  isNullOrEmptySpace,
  NO_VALUE_DISPLAY,
  resolveNotificationContent,
} from "@ryde/shared";

import { FramerTooltip } from "../../common";
import { useDecorateWithMark } from "../../utils";
import { IRenderColumnTemplate } from "./_core";

export const NotificationContentGridTemplate: FC<IRenderColumnTemplate> = ({
  value,
  name,
}) => {
  const { decorateValue } = useDecorateWithMark();
  const language = useRecoilValue(appLanguageSelector);
  const content = value ? resolveNotificationContent(value, language) : "";

  const highlightedContent = useMemo(() => {
    return decorateValue(content);
  }, [content, decorateValue]);

  return (
    <div
      className="cell_simple"
      data-e2e-id={`${name}`}
      data-e2e-value={content}
      data-e2e-template={"text-cell-notification-content"}
    >
      <FramerTooltip content={content} rtlStrippedBottomLeftPlacement>
        <span>
          {!isNullOrEmptySpace(content) ? highlightedContent : NO_VALUE_DISPLAY}
        </span>
      </FramerTooltip>
    </div>
  );
};
